<template>
  <activity-log
    title="Audit Trail"
    :scope="scope"
    :locked-fields="lockedFields"
    :saved-views="savedViews"
  />
</template>

<script>
import ActivityLog from '@/pages/logs/activity/index.vue'

/**
 * Audit Trail — every entry that changed stored data, with its field-level before/after.
 *
 * This screen was previously empty, always. It read the `audit_trail` collection, whose only writer
 * required a route to declare `scope: "admin"` — something no route in this application ever did —
 * so nothing was ever written to it. It now reads the activity log, scoped to entries that recorded
 * an actual diff, which is what an audit trail means.
 *
 * `has_changes` is the scope rather than a category filter on purpose: a data change the system
 * could not diff is not useful as audit evidence, and a category filter would also admit failed
 * attempts that changed nothing.
 */
export default {
  name: 'AuditTrail',
  components: { ActivityLog },
  data() {
    return {
      scope: {
        has_changes: 'true',
      },
      lockedFields: ['has_changes'],
      savedViews: [
        {
          label: 'Deletions',
          icon: 'Trash2Icon',
          filters: { action: 'delete,bulk_delete', period: '30d' },
        },
        {
          label: 'Permission changes',
          icon: 'UserCheckIcon',
          filters: { category: 'authorization', period: '90d' },
        },
        {
          label: 'Settings changes',
          icon: 'SettingsIcon',
          filters: { module: 'settings', period: '90d' },
        },
        {
          label: 'Member edits',
          icon: 'UsersIcon',
          filters: { module: 'member_profiles', period: '7d' },
        },
        {
          label: 'Geography edits',
          icon: 'MapIcon',
          filters: {
            module: 'regions,areas,districts,assemblies,mission_blocks,rmc',
            period: '30d',
          },
        },
      ],
    };
  },
};
</script>
